const assets = {
  images: {
    logo: require("./images/landbook-logo-240.png")
  }
};

export default assets;